export class Credentials implements CredentialsInterface
{
  username = "";
  password = "";
  isLoggedIn = false;

  public isValid(): boolean
  {
    return this.username != "" && this.password != "";
  }
}

interface CredentialsInterface
{
  username: string;
  password: string;
  isLoggedIn: boolean;
  isValid: () => boolean;
}

export class Cabinet implements CabinetInterface
{
  id: number|null = null;
  nom = "";
  url = "";
  credentials = new Credentials();

  constructor(nom: string, url: string, username?: string, password?: string)
  {
    this.nom = nom;
    this.url = url;

    if(username)
    {
      this.credentials.username = username;
    }

    if(password)
    {
      this.credentials.password = password;
    }
  }
}

interface CabinetInterface
{
  id: number|null;
  nom: string;
  url: string;
  credentials: Credentials;
}


export class Dossier implements DossierInterface
{
  id = "";
  nom = "";
  numero = "";

  constructor(id: string, nom: string, numero: string)
  {
    this.id = id;
    this.nom = nom;
    this.numero = numero;
  }
}

interface DossierInterface
{
  id: string;
  nom: string;
  numero: string;
}

export interface Attachment
{
    id: number;
    name: string;
    mimeContent?: string;
    contentType?: string;
    savePath?: string|null;
}
export const SaveMode = { ATTACHMENTS: 'a', MAIL: 'm' };

type FolderRole = 'courrier'
          | 'devis'
          | 'acte'
          | 'facture'
          | null;

export interface FolderTreeNode {
  name: string;
  relativePath: string;
  children: FolderTreeNode[];
  role: FolderRole;
}

export interface CachedFolderTreeNode
{
  repertoiresHierarchy: FolderTreeNode[],
  timestamp: string
}
